














import { Component, Prop, Vue } from 'vue-property-decorator';
import { BaseLoaderCircular } from '../base-loader-circular';

@Component({
  name: 'BaseModalSubContainer',
  components: {
    BaseLoaderCircular,
  },
})
export default class BaseModalSubContainer extends Vue {
  @Prop() loading: boolean;
  @Prop({ default: true }) padded: boolean;
  @Prop({ default: true }) closable: boolean;
}
